module.exports = __webpack_public_path__ + "082127d5fd1624a891838d3fb6ef3fdf.svg";